import React, { useState, useContext } from 'react';
import './index.css';
import FeaturedInMedia from '../featured_in_media';
import TextLeftImgRight from '../hero_sections/txt_left_img_right';
import Context from '../../utils/context';
import EverythingYouNeed from '../everything_you_need_section';
import { validateEmail, validateText, validateZipcode, validateEarlyAccessOptions } from '../../helpers';
import ErrorMessage from '../ui_kit/utilities/error_message';
import LoadingScreen from '../loading_screen';
import styles from '../for_mentors/for_mentors.module.css';
import AgreeToTerms from '../ui_kit/utilities/agree_to_terms';
import DropdownInput from '../ui_kit/utilities/dropdown_input';
import ScrollTo from '../scroll_to/index';
import { createProductDiscoveryContacts } from '../../api/product_discovery_contacts';

export default function ProductDiscovery({}) {
  const context = useContext(Context);
  const viewport = context.viewport;
  const isMobile = viewport.getIsMobile();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [procedures, setProcedures] = useState('');
  const [acceptedTerms, setTerms] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [zipError, setZipError] = useState('');
  const [earlyAccessError, setEarlyAccessError] = useState('');
  const [chosenEarlyAccess, setChosenEarlyAccess] = useState([]);

  var checkedName = validateText(fullName);
  var checkedEmail = validateEmail(email);
  var checkedZipcode = validateZipcode(zipcode);
  var checkedEarlyAccess = validateEarlyAccessOptions(chosenEarlyAccess);

  const filterableEarlyAccess = [
    {
      value: 'Patient social community',
    },
    {
      value: 'One on one support',
    },
    {
      value: 'Provider finder',
    },
    {
      value: 'Insurance navigation',
    },
    {
      value: 'Education about my procedure',
    },
  ];

  const setAcceptedTerms = () => {
    setTerms(!acceptedTerms);
    if (chosenEarlyAccess.length === 0) {
      setEarlyAccessError('Please select what you would like early access to');
    } else {
      setEarlyAccessError('');
    }
    validate();
  };

  const validate = () => {
    if (checkedName == false && fullName !== '') {
      setNameError('Please enter a name without special characters');
    } else {
      setNameError('');
    }
    if (checkedEmail === false && email !== '') {
      setEmailError('Please enter a valid email');
    } else {
      setEmailError('');
    }
    if (checkedZipcode == false && zipcode !== '') {
      setZipError('Please enter a valid zipcode');
    } else {
      setZipError('');
    }
  };

  const onSubmit = () => {
    setLoading(true);
    createProductDiscoveryContacts(
      email,
      fullName,
      firstName,
      lastName,
      earlyAccessOptions,
      zipcode,
      procedures,
      () => {
        setLoading(false);
        setSuccess(true);
      }
    );
  };

  const scrollToQuestionnaire = () => {
    ScrollTo('#product-discovery-landing01', 100);
  };

  const x = chosenEarlyAccess.map((c) => c.value);
  const earlyAccessOptions = x.join(', ');

  const firstName = fullName.split(' ')[0];
  const lastName = fullName.split(' ')[1];
  return (
    <div className='product-discovery'>
      <TextLeftImgRight
        bgImgFit={true}
        headline={'We simplify your surgery experience'}
        para={'Get connected to people, doctors, resources, and information all in one place.'}
        bg={'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platfom-landing-hero.jpg'}
        bgColor={'#F1FEFF'}
        // heightOfImage={'700px'}
        actionContent={
          <div className='btn-wrap'>
            <button
              onClick={scrollToQuestionnaire}
              className='maincta'
              data-gtm-click-label='Product Discovery Primary CTA'
            >
              Request early access
            </button>
          </div>
        }
        imgOffset={false}
        heightOfImage={isMobile ? '300px' : '500px'}
        topImage={
          <svg width='182' height='42' viewBox='0 0 182 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M178.521 1.14843H177.869V3.21046C177.869 3.32921 177.842 3.41764 177.787 3.47572C177.732 3.53252 177.661 3.5609 177.573 3.5609C177.485 3.5609 177.412 3.53186 177.356 3.47378C177.301 3.41569 177.274 3.32792 177.274 3.21046V1.14843H176.622C176.52 1.14843 176.444 1.12714 176.394 1.08454C176.345 1.04066 176.32 0.983211 176.32 0.912218C176.32 0.838644 176.345 0.780558 176.396 0.737962C176.449 0.695367 176.524 0.674072 176.622 0.674072H178.521C178.624 0.674072 178.701 0.696019 178.75 0.739906C178.801 0.783792 178.827 0.841226 178.827 0.912218C178.827 0.983211 178.801 1.04066 178.75 1.08454C178.699 1.12714 178.623 1.14843 178.521 1.14843Z'
              fill='#314D69'
            />
            <path
              d='M180.177 3.0846L179.704 1.27623V3.23562C179.704 3.34405 179.679 3.42537 179.628 3.47958C179.578 3.5338 179.512 3.5609 179.429 3.5609C179.348 3.5609 179.282 3.53444 179.231 3.48151C179.18 3.4273 179.155 3.34534 179.155 3.23562V0.989661C179.155 0.865746 179.188 0.782501 179.255 0.739906C179.323 0.696019 179.413 0.674072 179.527 0.674072H179.712C179.824 0.674072 179.904 0.683747 179.954 0.703109C180.005 0.72247 180.042 0.757329 180.066 0.80767C180.09 0.85801 180.118 0.939976 180.149 1.05356L180.577 2.60832L181.006 1.05356C181.037 0.939976 181.064 0.85801 181.089 0.80767C181.113 0.757329 181.15 0.72247 181.199 0.703109C181.25 0.683747 181.331 0.674072 181.443 0.674072H181.628C181.742 0.674072 181.832 0.696019 181.899 0.739906C181.966 0.782501 182 0.865746 182 0.989661V3.23562C182 3.34405 181.975 3.42537 181.924 3.47958C181.874 3.5338 181.807 3.5609 181.722 3.5609C181.643 3.5609 181.578 3.5338 181.527 3.47958C181.476 3.42537 181.451 3.34405 181.451 3.23562V1.27623L180.978 3.0846C180.947 3.20206 180.922 3.28855 180.901 3.34406C180.883 3.39827 180.847 3.44796 180.795 3.49314C180.742 3.53831 180.67 3.5609 180.577 3.5609C180.508 3.5609 180.449 3.54606 180.4 3.51637C180.352 3.48797 180.315 3.45119 180.288 3.40601C180.261 3.36084 180.239 3.31113 180.223 3.25692C180.209 3.20142 180.193 3.14397 180.177 3.0846Z'
              fill='#314D69'
            />
            <path
              d='M6.67853 34.5219H3.48598V39.209C3.48598 39.8792 3.32166 40.3874 2.99302 40.7338C2.66437 41.0801 2.24965 41.2533 1.74886 41.2533C1.22459 41.2533 0.80205 41.0839 0.48123 40.7451C0.16041 40.3987 0 39.8942 0 39.2316V26.469C0 25.7311 0.17606 25.2041 0.528179 24.8878C0.880299 24.5716 1.43978 24.4135 2.20662 24.4135H6.67853C8.00094 24.4135 9.01817 24.5113 9.73023 24.7071C10.4345 24.8953 11.0409 25.2078 11.5495 25.6445C12.066 26.0813 12.4572 26.6158 12.7232 27.2483C12.9893 27.8808 13.1223 28.5923 13.1223 29.3829C13.1223 31.0696 12.5824 32.3496 11.5026 33.223C10.4227 34.0889 8.81472 34.5219 6.67853 34.5219ZM5.83345 26.9321H3.48598V31.9919H5.83345C6.65506 31.9919 7.33973 31.9091 7.88748 31.7435C8.44304 31.5778 8.86559 31.3068 9.15511 30.9303C9.44463 30.5538 9.58939 30.0606 9.58939 29.4507C9.58939 28.7204 9.36638 28.1255 8.92036 27.6662C8.41957 27.1768 7.3906 26.9321 5.83345 26.9321Z'
              fill='#314D69'
            />
            <path
              d='M22.0319 39.514C21.2572 40.0937 20.506 40.5305 19.7783 40.8241C19.0584 41.1102 18.2486 41.2533 17.3487 41.2533C16.5271 41.2533 15.8033 41.0989 15.1773 40.7902C14.5591 40.474 14.0818 40.0486 13.7453 39.514C13.4089 38.9794 13.2406 38.3996 13.2406 37.7746C13.2406 36.9313 13.5184 36.2123 14.074 35.6174C14.6295 35.0226 15.3925 34.6235 16.3628 34.4202C16.5662 34.375 17.0709 34.2734 17.8769 34.1153C18.6828 33.9572 19.3714 33.8141 19.9426 33.6861C20.5217 33.5506 21.1477 33.3887 21.8206 33.2004C21.7815 32.3872 21.6093 31.7924 21.3042 31.4159C21.0068 31.0319 20.3847 30.8399 19.4379 30.8399C18.6241 30.8399 18.0099 30.9491 17.5952 31.1675C17.1883 31.3858 16.8362 31.7133 16.5388 32.1501C16.2493 32.5868 16.0419 32.8767 15.9167 33.0197C15.7994 33.1553 15.5411 33.223 15.1421 33.223C14.7821 33.223 14.4691 33.1138 14.2031 32.8955C13.9449 32.6696 13.8158 32.3835 13.8158 32.0371C13.8158 31.495 14.0153 30.9679 14.4144 30.4559C14.8134 29.9439 15.4355 29.5223 16.2806 29.191C17.1257 28.8597 18.1781 28.694 19.4379 28.694C20.8464 28.694 21.9536 28.8559 22.7596 29.1797C23.5656 29.4959 24.1329 30.0004 24.4615 30.6931C24.798 31.3858 24.9662 32.3044 24.9662 33.4489C24.9662 34.1718 24.9623 34.7854 24.9545 35.2899C24.9545 35.7944 24.9506 36.3553 24.9427 36.9727C24.9427 37.5525 25.0405 38.1587 25.2362 38.7911C25.4396 39.4161 25.5413 39.8189 25.5413 39.9996C25.5413 40.3159 25.3848 40.6058 25.0718 40.8693C24.7667 41.1253 24.4185 41.2533 24.0272 41.2533C23.6986 41.2533 23.3738 41.1065 23.053 40.8128C22.7322 40.5116 22.3918 40.0787 22.0319 39.514ZM21.8206 35.0527C21.3511 35.2184 20.6664 35.3953 19.7666 35.5835C18.8745 35.7643 18.2564 35.8998 17.9121 35.9901C17.5678 36.073 17.2391 36.2424 16.9261 36.4984C16.6132 36.7469 16.4567 37.097 16.4567 37.5488C16.4567 38.0156 16.6405 38.4147 17.0083 38.746C17.3761 39.0697 17.8573 39.2316 18.452 39.2316C19.0858 39.2316 19.6688 39.0998 20.2009 38.8363C20.7408 38.5652 21.1359 38.2189 21.3863 37.7972C21.6758 37.3304 21.8206 36.5624 21.8206 35.4932V35.0527Z'
              fill='#314D69'
            />
            <path
              d='M26.8334 28.9877H27.1855V27.1354C27.1855 26.6384 27.1972 26.2507 27.2207 25.9721C27.252 25.6859 27.3303 25.4412 27.4555 25.2379C27.5807 25.0271 27.7606 24.8577 27.9954 24.7297C28.2301 24.5942 28.4923 24.5264 28.7818 24.5264C29.1887 24.5264 29.5564 24.6732 29.8851 24.9669C30.1042 25.1626 30.2411 25.4036 30.2959 25.6897C30.3585 25.9683 30.3898 26.3674 30.3898 26.8869V28.9877H31.5635C32.0174 28.9877 32.3617 29.0931 32.5964 29.3039C32.839 29.5072 32.9603 29.7707 32.9603 30.0945C32.9603 30.5086 32.7881 30.7985 32.4438 30.9642C32.1073 31.1298 31.6222 31.2126 30.9884 31.2126H30.3898V36.8824C30.3898 37.3643 30.4054 37.737 30.4367 38.0005C30.4759 38.2565 30.5698 38.4674 30.7184 38.633C30.8749 38.7911 31.1253 38.8702 31.4696 38.8702C31.6574 38.8702 31.9117 38.8401 32.2325 38.7798C32.5534 38.7121 32.8038 38.6782 32.9837 38.6782C33.242 38.6782 33.4728 38.7798 33.6762 38.9831C33.8875 39.1789 33.9931 39.4236 33.9931 39.7173C33.9931 40.2142 33.7114 40.5945 33.1481 40.858C32.5847 41.1215 31.7748 41.2533 30.7184 41.2533C29.7169 41.2533 28.9578 41.0914 28.4414 40.7676C27.925 40.4439 27.5846 39.9959 27.4202 39.4236C27.2638 38.8514 27.1855 38.0871 27.1855 37.1309V31.2126H26.763C26.3013 31.2126 25.9492 31.1072 25.7066 30.8964C25.464 30.6856 25.3427 30.4183 25.3427 30.0945C25.3427 29.7707 25.4679 29.5072 25.7183 29.3039C25.9766 29.0931 26.3482 28.9877 26.8334 28.9877Z'
              fill='#314D69'
            />
            <path
              d='M37.4214 30.4672V39.3784C37.4214 39.9959 37.2688 40.4627 36.9636 40.7789C36.6585 41.0952 36.2711 41.2533 35.8016 41.2533C35.3321 41.2533 34.9487 41.0914 34.6514 40.7676C34.3619 40.4439 34.2171 39.9808 34.2171 39.3784V30.5576C34.2171 29.9477 34.3619 29.4884 34.6514 29.1797C34.9487 28.8709 35.3321 28.7166 35.8016 28.7166C36.2711 28.7166 36.6585 28.8709 36.9636 29.1797C37.2688 29.4884 37.4214 29.9176 37.4214 30.4672ZM35.8368 27.2822C35.3908 27.2822 35.0074 27.1504 34.6866 26.8869C34.3736 26.6234 34.2171 26.2507 34.2171 25.7688C34.2171 25.3321 34.3775 24.9744 34.6983 24.6958C35.027 24.4097 35.4065 24.2666 35.8368 24.2666C36.2516 24.2666 36.6193 24.3946 36.9401 24.6506C37.261 24.9066 37.4214 25.2794 37.4214 25.7688C37.4214 26.2431 37.2649 26.6158 36.9519 26.8869C36.6389 27.1504 36.2672 27.2822 35.8368 27.2822Z'
              fill='#314D69'
            />
            <path
              d='M48.7254 35.7417H42.4576C42.4655 36.4419 42.6102 37.0593 42.8919 37.5939C43.1814 38.1285 43.5609 38.5314 44.0304 38.8024C44.5077 39.0735 45.032 39.209 45.6032 39.209C45.9866 39.209 46.3349 39.1676 46.6478 39.0848C46.9687 38.9944 47.2778 38.8589 47.5751 38.6782C47.8724 38.4899 48.1463 38.2904 48.3967 38.0796C48.6471 37.8688 48.9718 37.5826 49.3709 37.2212C49.5352 37.0857 49.77 37.0179 50.0751 37.0179C50.4038 37.0179 50.6698 37.1045 50.8733 37.2777C51.0767 37.4509 51.1785 37.6956 51.1785 38.0118C51.1785 38.2904 51.065 38.618 50.8381 38.9944C50.6111 39.3634 50.2669 39.721 49.8052 40.0674C49.3513 40.4062 48.7762 40.6886 48.0798 40.9145C47.3912 41.1404 46.597 41.2533 45.6971 41.2533C43.6392 41.2533 42.039 40.6886 40.8966 39.5591C39.7541 38.4297 39.1829 36.8974 39.1829 34.9624C39.1829 34.0513 39.3238 33.208 39.6055 32.4324C39.8872 31.6494 40.298 30.9792 40.8379 30.422C41.3778 29.8648 42.0429 29.4394 42.8332 29.1458C43.6235 28.8446 44.4999 28.694 45.4624 28.694C46.7144 28.694 47.7864 28.95 48.6784 29.462C49.5783 29.9665 50.2512 30.6216 50.6972 31.4272C51.1432 32.2329 51.3662 33.0536 51.3662 33.8894C51.3662 34.6649 51.1354 35.1694 50.6737 35.4028C50.2121 35.6287 49.5626 35.7417 48.7254 35.7417ZM42.4576 33.991H48.2676C48.1894 32.9369 47.892 32.1501 47.3756 31.6305C46.8669 31.1035 46.194 30.8399 45.3567 30.8399C44.5586 30.8399 43.9013 31.1072 43.3849 31.6418C42.8763 32.1689 42.5672 32.952 42.4576 33.991Z'
              fill='#314D69'
            />
            <path
              d='M56.0269 30.422V30.7948C56.5903 30.0794 57.2045 29.5561 57.8697 29.2248C58.5426 28.886 59.3134 28.7166 60.1819 28.7166C61.027 28.7166 61.7821 28.8935 62.4472 29.2474C63.1123 29.6013 63.6092 30.102 63.9379 30.7496C64.1491 31.126 64.2861 31.5326 64.3487 31.9694C64.4113 32.4061 64.4426 32.9633 64.4426 33.6409V39.3784C64.4426 39.9959 64.2939 40.4627 63.9965 40.7789C63.707 41.0952 63.3275 41.2533 62.858 41.2533C62.3807 41.2533 61.9934 41.0914 61.696 40.7676C61.3987 40.4439 61.25 39.9808 61.25 39.3784V34.2395C61.25 33.223 61.1013 32.4475 60.804 31.9129C60.5145 31.3708 59.9315 31.0997 59.0551 31.0997C58.4839 31.0997 57.9636 31.2653 57.4941 31.5966C57.0246 31.9204 56.6803 32.3684 56.4612 32.9407C56.3047 33.4 56.2264 34.2583 56.2264 35.5158V39.3784C56.2264 40.0034 56.0739 40.474 55.7687 40.7902C55.4713 41.0989 55.084 41.2533 54.6067 41.2533C54.145 41.2533 53.7655 41.0914 53.4682 40.7676C53.1708 40.4439 53.0222 39.9808 53.0222 39.3784V30.4672C53.0222 29.8799 53.1552 29.4432 53.4212 29.1571C53.6873 28.8634 54.0511 28.7166 54.5128 28.7166C54.7945 28.7166 55.0488 28.7806 55.2757 28.9086C55.5026 29.0366 55.6826 29.2286 55.8156 29.4846C55.9565 29.7406 56.0269 30.0531 56.0269 30.422Z'
              fill='#314D69'
            />
            <path
              d='M66.8614 28.9877H67.2135V27.1354C67.2135 26.6384 67.2252 26.2507 67.2487 25.9721C67.28 25.6859 67.3583 25.4412 67.4835 25.2379C67.6087 25.0271 67.7886 24.8577 68.0234 24.7297C68.2581 24.5942 68.5203 24.5264 68.8098 24.5264C69.2167 24.5264 69.5844 24.6732 69.9131 24.9669C70.1322 25.1626 70.2691 25.4036 70.3239 25.6897C70.3865 25.9683 70.4178 26.3674 70.4178 26.8869V28.9877H71.5915C72.0454 28.9877 72.3897 29.0931 72.6244 29.3039C72.867 29.5072 72.9883 29.7707 72.9883 30.0945C72.9883 30.5086 72.8161 30.7985 72.4718 30.9642C72.1353 31.1298 71.6502 31.2126 71.0164 31.2126H70.4178V36.8824C70.4178 37.3643 70.4334 37.737 70.4647 38.0005C70.5039 38.2565 70.5978 38.4674 70.7464 38.633C70.9029 38.7911 71.1533 38.8702 71.4976 38.8702C71.6854 38.8702 71.9397 38.8401 72.2605 38.7798C72.5814 38.7121 72.8318 38.6782 73.0117 38.6782C73.27 38.6782 73.5008 38.7798 73.7042 38.9831C73.9155 39.1789 74.0211 39.4236 74.0211 39.7173C74.0211 40.2142 73.7394 40.5945 73.1761 40.858C72.6127 41.1215 71.8028 41.2533 70.7464 41.2533C69.7448 41.2533 68.9858 41.0914 68.4694 40.7676C67.953 40.4439 67.6126 39.9959 67.4482 39.4236C67.2917 38.8514 67.2135 38.0871 67.2135 37.1309V31.2126H66.791C66.3293 31.2126 65.9772 31.1072 65.7346 30.8964C65.492 30.6856 65.3707 30.4183 65.3707 30.0945C65.3707 29.7707 65.4959 29.5072 65.7463 29.3039C66.0046 29.0931 66.3762 28.9877 66.8614 28.9877Z'
              fill='#314D69'
            />
            <path
              d='M81.1466 34.5219H77.9541V39.209C77.9541 39.8792 77.7898 40.3874 77.4611 40.7338C77.1325 41.0801 76.7178 41.2533 76.217 41.2533C75.6927 41.2533 75.2702 41.0839 74.9493 40.7451C74.6285 40.3987 74.4681 39.8942 74.4681 39.2316V26.469C74.4681 25.7311 74.6442 25.2041 74.9963 24.8878C75.3484 24.5716 75.9079 24.4135 76.6747 24.4135H81.1466C82.469 24.4135 83.4863 24.5113 84.1983 24.7071C84.9026 24.8953 85.509 25.2078 86.0176 25.6445C86.5341 26.0813 86.9253 26.6158 87.1914 27.2483C87.4574 27.8808 87.5904 28.5923 87.5904 29.3829C87.5904 31.0696 87.0505 32.3496 85.9707 33.223C84.8908 34.0889 83.2828 34.5219 81.1466 34.5219ZM80.3016 26.9321H77.9541V31.9919H80.3016C81.1232 31.9919 81.8078 31.9091 82.3556 31.7435C82.9111 31.5778 83.3337 31.3068 83.6232 30.9303C83.9127 30.5538 84.0575 30.0606 84.0575 29.4507C84.0575 28.7204 83.8345 28.1255 83.3885 27.6662C82.8877 27.1768 81.8587 26.9321 80.3016 26.9321Z'
              fill='#314D69'
            />
            <path
              d='M96.5 39.514C95.7253 40.0937 94.9741 40.5305 94.2464 40.8241C93.5265 41.1102 92.7167 41.2533 91.8168 41.2533C90.9952 41.2533 90.2714 41.0989 89.6454 40.7902C89.0272 40.474 88.5499 40.0486 88.2134 39.514C87.877 38.9794 87.7087 38.3996 87.7087 37.7746C87.7087 36.9313 87.9865 36.2123 88.5421 35.6174C89.0976 35.0226 89.8606 34.6235 90.8309 34.4202C91.0343 34.375 91.539 34.2734 92.345 34.1153C93.1509 33.9572 93.8395 33.8141 94.4107 33.6861C94.9898 33.5506 95.6158 33.3887 96.2887 33.2004C96.2496 32.3872 96.0774 31.7924 95.7723 31.4159C95.4749 31.0319 94.8528 30.8399 93.906 30.8399C93.0922 30.8399 92.478 30.9491 92.0633 31.1675C91.6564 31.3858 91.3043 31.7133 91.0069 32.1501C90.7174 32.5868 90.51 32.8767 90.3848 33.0197C90.2675 33.1553 90.0092 33.223 89.6102 33.223C89.2502 33.223 88.9372 33.1138 88.6712 32.8955C88.413 32.6696 88.2839 32.3835 88.2839 32.0371C88.2839 31.495 88.4834 30.9679 88.8825 30.4559C89.2815 29.9439 89.9036 29.5223 90.7487 29.191C91.5938 28.8597 92.6462 28.694 93.906 28.694C95.3145 28.694 96.4217 28.8559 97.2277 29.1797C98.0337 29.4959 98.601 30.0004 98.9296 30.6931C99.2661 31.3858 99.4343 32.3044 99.4343 33.4489C99.4343 34.1718 99.4304 34.7854 99.4226 35.2899C99.4226 35.7944 99.4187 36.3553 99.4108 36.9727C99.4108 37.5525 99.5086 38.1587 99.7043 38.7911C99.9077 39.4161 100.009 39.8189 100.009 39.9996C100.009 40.3159 99.8529 40.6058 99.5399 40.8693C99.2348 41.1253 98.8866 41.2533 98.4953 41.2533C98.1667 41.2533 97.8419 41.1065 97.5211 40.8128C97.2003 40.5116 96.8599 40.0787 96.5 39.514ZM96.2887 35.0527C95.8192 35.2184 95.1345 35.3953 94.2347 35.5835C93.3427 35.7643 92.7245 35.8998 92.3802 35.9901C92.0359 36.073 91.7072 36.2424 91.3942 36.4984C91.0813 36.7469 90.9248 37.097 90.9248 37.5488C90.9248 38.0156 91.1086 38.4147 91.4764 38.746C91.8442 39.0697 92.3254 39.2316 92.9201 39.2316C93.5539 39.2316 94.1369 39.0998 94.669 38.8363C95.2089 38.5652 95.604 38.2189 95.8544 37.7972C96.144 37.3304 96.2887 36.5624 96.2887 35.4932V35.0527Z'
              fill='#314D69'
            />
            <path
              d='M104.917 36.8033V39.3784C104.917 40.0034 104.764 40.474 104.459 40.7902C104.154 41.0989 103.766 41.2533 103.297 41.2533C102.835 41.2533 102.456 41.0952 102.158 40.7789C101.861 40.4627 101.712 39.9959 101.712 39.3784V30.7948C101.712 29.4093 102.233 28.7166 103.273 28.7166C103.805 28.7166 104.189 28.8785 104.424 29.2023C104.658 29.526 104.787 30.0041 104.811 30.6366C105.194 30.0041 105.586 29.526 105.985 29.2023C106.392 28.8785 106.931 28.7166 107.604 28.7166C108.277 28.7166 108.931 28.8785 109.565 29.2023C110.198 29.526 110.515 29.9552 110.515 30.4898C110.515 30.8663 110.378 31.1788 110.104 31.4272C109.838 31.6682 109.549 31.7886 109.236 31.7886C109.119 31.7886 108.833 31.7209 108.379 31.5854C107.933 31.4423 107.538 31.3708 107.194 31.3708C106.724 31.3708 106.341 31.4912 106.043 31.7322C105.746 31.9656 105.515 32.3157 105.351 32.7825C105.187 33.2494 105.073 33.8066 105.01 34.4541C104.948 35.0941 104.917 35.8772 104.917 36.8033Z'
              fill='#314D69'
            />
            <path
              d='M111.796 28.9877H112.148V27.1354C112.148 26.6384 112.159 26.2507 112.183 25.9721C112.214 25.6859 112.292 25.4412 112.418 25.2379C112.543 25.0271 112.723 24.8577 112.958 24.7297C113.192 24.5942 113.454 24.5264 113.744 24.5264C114.151 24.5264 114.519 24.6732 114.847 24.9669C115.066 25.1626 115.203 25.4036 115.258 25.6897C115.321 25.9683 115.352 26.3674 115.352 26.8869V28.9877H116.526C116.98 28.9877 117.324 29.0931 117.559 29.3039C117.801 29.5072 117.922 29.7707 117.922 30.0945C117.922 30.5086 117.75 30.7985 117.406 30.9642C117.07 31.1298 116.584 31.2126 115.951 31.2126H115.352V36.8824C115.352 37.3643 115.368 37.737 115.399 38.0005C115.438 38.2565 115.532 38.4674 115.681 38.633C115.837 38.7911 116.088 38.8702 116.432 38.8702C116.62 38.8702 116.874 38.8401 117.195 38.7798C117.516 38.7121 117.766 38.6782 117.946 38.6782C118.204 38.6782 118.435 38.7798 118.638 38.9831C118.85 39.1789 118.955 39.4236 118.955 39.7173C118.955 40.2142 118.674 40.5945 118.11 40.858C117.547 41.1215 116.737 41.2533 115.681 41.2533C114.679 41.2533 113.92 41.0914 113.404 40.7676C112.887 40.4439 112.547 39.9959 112.382 39.4236C112.226 38.8514 112.148 38.0871 112.148 37.1309V31.2126H111.725C111.263 31.2126 110.911 31.1072 110.669 30.8964C110.426 30.6856 110.305 30.4183 110.305 30.0945C110.305 29.7707 110.43 29.5072 110.681 29.3039C110.939 29.0931 111.31 28.9877 111.796 28.9877Z'
              fill='#314D69'
            />
            <path
              d='M122.09 30.422V30.7948C122.654 30.0794 123.268 29.5561 123.933 29.2248C124.606 28.886 125.377 28.7166 126.245 28.7166C127.09 28.7166 127.845 28.8935 128.51 29.2474C129.176 29.6013 129.672 30.102 130.001 30.7496C130.212 31.126 130.349 31.5326 130.412 31.9694C130.475 32.4061 130.506 32.9633 130.506 33.6409V39.3784C130.506 39.9959 130.357 40.4627 130.06 40.7789C129.77 41.0952 129.391 41.2533 128.921 41.2533C128.444 41.2533 128.057 41.0914 127.759 40.7676C127.462 40.4439 127.313 39.9808 127.313 39.3784V34.2395C127.313 33.223 127.165 32.4475 126.867 31.9129C126.578 31.3708 125.995 31.0997 125.118 31.0997C124.547 31.0997 124.027 31.2653 123.557 31.5966C123.088 31.9204 122.744 32.3684 122.524 32.9407C122.368 33.4 122.29 34.2583 122.29 35.5158V39.3784C122.29 40.0034 122.137 40.474 121.832 40.7902C121.535 41.0989 121.147 41.2533 120.67 41.2533C120.208 41.2533 119.829 41.0914 119.531 40.7676C119.234 40.4439 119.085 39.9808 119.085 39.3784V30.4672C119.085 29.8799 119.218 29.4432 119.484 29.1571C119.751 28.8634 120.114 28.7166 120.576 28.7166C120.858 28.7166 121.112 28.7806 121.339 28.9086C121.566 29.0366 121.746 29.2286 121.879 29.4846C122.02 29.7406 122.09 30.0531 122.09 30.422Z'
              fill='#314D69'
            />
            <path
              d='M141.692 35.7417H135.425C135.432 36.4419 135.577 37.0593 135.859 37.5939C136.148 38.1285 136.528 38.5314 136.997 38.8024C137.475 39.0735 137.999 39.209 138.57 39.209C138.954 39.209 139.302 39.1676 139.615 39.0848C139.936 38.9944 140.245 38.8589 140.542 38.6782C140.839 38.4899 141.113 38.2904 141.364 38.0796C141.614 37.8688 141.939 37.5826 142.338 37.2212C142.502 37.0857 142.737 37.0179 143.042 37.0179C143.371 37.0179 143.637 37.1045 143.84 37.2777C144.044 37.4509 144.145 37.6956 144.145 38.0118C144.145 38.2904 144.032 38.618 143.805 38.9944C143.578 39.3634 143.234 39.721 142.772 40.0674C142.318 40.4062 141.743 40.6886 141.047 40.9145C140.358 41.1404 139.564 41.2533 138.664 41.2533C136.606 41.2533 135.006 40.6886 133.864 39.5591C132.721 38.4297 132.15 36.8974 132.15 34.9624C132.15 34.0513 132.291 33.208 132.573 32.4324C132.854 31.6494 133.265 30.9792 133.805 30.422C134.345 29.8648 135.01 29.4394 135.8 29.1458C136.591 28.8446 137.467 28.694 138.429 28.694C139.681 28.694 140.753 28.95 141.645 29.462C142.545 29.9665 143.218 30.6216 143.664 31.4272C144.11 32.2329 144.333 33.0536 144.333 33.8894C144.333 34.6649 144.102 35.1694 143.641 35.4028C143.179 35.6287 142.53 35.7417 141.692 35.7417ZM135.425 33.991H141.235C141.156 32.9369 140.859 32.1501 140.343 31.6305C139.834 31.1035 139.161 30.8399 138.324 30.8399C137.526 30.8399 136.868 31.1072 136.352 31.6418C135.843 32.1689 135.534 32.952 135.425 33.991Z'
              fill='#314D69'
            />
            <path
              d='M149.264 36.8033V39.3784C149.264 40.0034 149.111 40.474 148.806 40.7902C148.501 41.0989 148.114 41.2533 147.644 41.2533C147.182 41.2533 146.803 41.0952 146.506 40.7789C146.208 40.4627 146.06 39.9959 146.06 39.3784V30.7948C146.06 29.4093 146.58 28.7166 147.621 28.7166C148.153 28.7166 148.536 28.8785 148.771 29.2023C149.006 29.526 149.135 30.0041 149.158 30.6366C149.542 30.0041 149.933 29.526 150.332 29.2023C150.739 28.8785 151.279 28.7166 151.952 28.7166C152.625 28.7166 153.278 28.8785 153.912 29.2023C154.546 29.526 154.863 29.9552 154.863 30.4898C154.863 30.8663 154.726 31.1788 154.452 31.4272C154.186 31.6682 153.896 31.7886 153.583 31.7886C153.466 31.7886 153.18 31.7209 152.726 31.5854C152.28 31.4423 151.885 31.3708 151.541 31.3708C151.071 31.3708 150.688 31.4912 150.391 31.7322C150.093 31.9656 149.863 32.3157 149.698 32.7825C149.534 33.2494 149.42 33.8066 149.358 34.4541C149.295 35.0941 149.264 35.8772 149.264 36.8033Z'
              fill='#314D69'
            />
            <path
              d='M160.927 9.02354C161.496 9.02354 161.958 8.53904 161.958 7.94139C161.958 7.34374 161.496 6.85924 160.927 6.85924C160.358 6.85924 159.897 7.34374 159.897 7.94139C159.897 8.53904 160.358 9.02354 160.927 9.02354Z'
              fill='#314D69'
            />
            <path
              d='M160.927 9.14922C160.7 9.14922 160.477 9.07833 160.288 8.94551C160.099 8.8127 159.951 8.62392 159.864 8.40307C159.777 8.18222 159.754 7.9392 159.799 7.70477C159.843 7.47033 159.953 7.25501 160.114 7.08603C160.275 6.91705 160.48 6.802 160.703 6.75545C160.927 6.70889 161.158 6.73291 161.368 6.82447C161.578 6.91603 161.758 7.07102 161.884 7.26983C162.011 7.46865 162.078 7.70235 162.078 7.94139C162.078 8.26168 161.956 8.5687 161.74 8.79512C161.525 9.02155 161.232 9.14888 160.927 9.14922ZM160.927 6.98493C160.747 6.98493 160.571 7.04102 160.421 7.14612C160.272 7.25122 160.155 7.4006 160.086 7.57537C160.017 7.75014 159.999 7.94245 160.034 8.12799C160.069 8.31352 160.156 8.48394 160.283 8.61771C160.411 8.75147 160.573 8.84256 160.75 8.87947C160.926 8.91637 161.109 8.89744 161.276 8.82504C161.442 8.75265 161.585 8.63006 161.685 8.47277C161.785 8.31548 161.838 8.13056 161.838 7.94139C161.838 7.68777 161.742 7.44459 161.571 7.26525C161.4 7.08592 161.169 6.98509 160.927 6.98493Z'
              fill='#314D69'
            />
            <path
              d='M166.57 9.02354C167.139 9.02354 167.6 8.53904 167.6 7.94139C167.6 7.34374 167.139 6.85924 166.57 6.85924C166.001 6.85924 165.539 7.34374 165.539 7.94139C165.539 8.53904 166.001 9.02354 166.57 9.02354Z'
              fill='#314D69'
            />
            <path
              d='M166.569 9.14922C166.342 9.14922 166.119 9.07833 165.93 8.94551C165.741 8.8127 165.593 8.62392 165.506 8.40307C165.419 8.18222 165.396 7.9392 165.441 7.70477C165.485 7.47033 165.595 7.25501 165.756 7.08603C165.917 6.91705 166.122 6.802 166.345 6.75545C166.568 6.70889 166.8 6.73291 167.01 6.82447C167.22 6.91603 167.4 7.07102 167.526 7.26983C167.653 7.46865 167.72 7.70235 167.72 7.94139C167.719 8.26173 167.598 8.56885 167.382 8.79531C167.167 9.02177 166.874 9.14905 166.569 9.14922ZM166.569 6.98493C166.389 6.98493 166.213 7.04102 166.063 7.14612C165.913 7.25122 165.797 7.4006 165.728 7.57537C165.659 7.75014 165.641 7.94245 165.676 8.12799C165.711 8.31352 165.798 8.48394 165.925 8.61771C166.053 8.75147 166.215 8.84256 166.392 8.87947C166.568 8.91637 166.751 8.89744 166.918 8.82504C167.084 8.75265 167.226 8.63006 167.326 8.47277C167.426 8.31548 167.48 8.13056 167.48 7.94139C167.48 7.68782 167.384 7.44473 167.213 7.26544C167.042 7.08614 166.811 6.98526 166.569 6.98493Z'
              fill='#314D69'
            />
            <path
              d='M159.407 25.4518C160.179 25.4518 160.181 24.1912 159.407 24.1912C158.633 24.1912 158.633 25.4518 159.407 25.4518Z'
              fill='#314D69'
            />
            <path
              d='M159.407 24.1912C157.826 24.1912 156.36 24.1283 155.028 23.0939C153.644 22.0193 152.886 20.3251 152.874 18.5347C152.855 16.1612 152.874 13.7864 152.874 11.4122V7.65922C152.874 6.52052 152.92 5.42141 153.426 4.37383C153.872 3.44695 154.553 2.66668 155.393 2.11813C156.233 1.56958 157.2 1.27382 158.189 1.26313C158.833 1.25433 159.478 1.26313 160.123 1.26313H168.147C168.997 1.26313 169.864 1.21034 170.695 1.43469C171.646 1.69698 172.511 2.22743 173.195 2.96867C173.88 3.70991 174.359 4.6337 174.58 5.6401C174.759 6.48093 174.705 7.37643 174.705 8.23423V12.3504C174.705 14.5197 174.786 16.7073 174.699 18.8753C174.615 20.9674 173.344 22.8721 171.528 23.7217C170.148 24.3677 168.844 24.0422 167.413 24.1937C166.986 24.2389 166.849 24.4903 166.651 24.8284L163.674 29.9054L163.271 30.5967L164.213 30.471L161.334 26.5899C160.859 25.9514 160.017 26.8488 160.485 27.4816L163.366 31.3583C163.613 31.6914 164.127 31.5406 164.309 31.2326L167.88 25.1413L167.361 25.4555C168.518 25.4555 169.724 25.5523 170.859 25.279C171.757 25.0548 172.6 24.6346 173.333 24.0459C174.067 23.4571 174.674 22.7129 175.116 21.8616C176.165 19.8249 175.905 17.4098 175.905 15.1764V7.49458C175.905 6.38416 175.827 5.30892 175.418 4.26448C175.065 3.37167 174.539 2.56598 173.873 1.89896C173.207 1.23194 172.416 0.718293 171.55 0.390879C170.615 0.0364484 169.656 0 168.678 0H158.48C155.304 0 152.386 2.16366 151.791 5.55275C151.647 6.37347 151.671 7.19733 151.671 8.02623V11.7842C151.671 14.0264 151.662 16.2686 151.671 18.5083C151.686 22.2079 154.462 25.3324 158.018 25.4468C158.481 25.4618 158.944 25.4468 159.406 25.4468C160.179 25.4468 160.18 24.1861 159.406 24.1861L159.407 24.1912Z'
              fill='#314D69'
            />
            <path
              d='M166.859 8.57169H167.751C168.04 8.57169 168.744 8.41459 168.936 8.68104C169.143 8.96949 168.851 9.67835 168.742 9.94543C168.601 10.2911 168.409 10.6141 168.23 10.9396L165.249 16.3616C164.938 16.9272 164.586 17.8793 163.89 17.9761C163.166 18.076 162.775 17.1748 162.476 16.6312L159.503 11.2224C159.159 10.5977 158.386 9.56712 158.661 8.81804C158.821 8.38254 159.55 8.57169 159.906 8.57169H161.037C161.81 8.57169 161.811 7.31045 161.037 7.31045H159.7C159.132 7.31045 158.544 7.25578 158.059 7.62089C157.105 8.33855 157.431 9.78078 157.855 10.7146C158.304 11.6994 158.891 12.6319 159.411 13.5765L161.33 17.0667C161.796 17.9151 162.274 18.8615 163.239 19.1569C164.376 19.5056 165.325 18.7 165.883 17.7316C167.065 15.6779 168.17 13.5708 169.313 11.492C169.841 10.5317 170.569 9.15048 169.971 8.04508C169.385 6.95665 167.845 7.31045 166.859 7.31045C166.087 7.31045 166.086 8.57169 166.859 8.57169Z'
              fill='#314D69'
            />
            <path
              d='M159.925 25.1395L164.307 19.001C164.771 18.3519 163.729 17.7228 163.271 18.365L158.889 24.501C158.425 25.1501 159.467 25.7792 159.925 25.1369V25.1395Z'
              fill='#314D69'
            />
          </svg>
        }
      />
      <FeaturedInMedia />

      <div className='container vid-cont pad-cont text-center'>
        <h2 className='headliner marg-top-100 marg-bottom-50'>
          Let us help you throughout your healthcare experience.
        </h2>
        <div className='row-vid'>
          <div className='col-1'></div>
          <div
            className='container vid'
            // style={{ position: "relative", zIndex: "0"}}
          >
            <svg
              className='svg-circles1'
              style={{
                position: 'absolute',
                top: '-10px',
                left: '-5px',
                zIndex: '-1',
              }}
              xmlns='http://www.w3.org/2000/svg'
              width='134'
              height='86'
              viewBox='0 0 134 86'
              fill='none'
            >
              <circle cx='3' cy='3' r='3' fill='#59B6BE' />
              <circle cx='19' cy='3' r='3' fill='#59B6BE' />
              <circle cx='35' cy='3' r='3' fill='#59B6BE' />
              <circle cx='51' cy='3' r='3' fill='#59B6BE' />
              <circle cx='67' cy='3' r='3' fill='#59B6BE' />
              <circle cx='83' cy='3' r='3' fill='#59B6BE' />
              <circle cx='99' cy='3' r='3' fill='#59B6BE' />
              <circle cx='115' cy='3' r='3' fill='#59B6BE' />
              <circle cx='131' cy='3' r='3' fill='#59B6BE' />
              <circle cx='3' cy='19' r='3' fill='#59B6BE' />
              <circle cx='19' cy='19' r='3' fill='#59B6BE' />
              <circle cx='35' cy='19' r='3' fill='#59B6BE' />
              <circle cx='51' cy='19' r='3' fill='#59B6BE' />
              <circle cx='67' cy='19' r='3' fill='#59B6BE' />
              <circle cx='83' cy='19' r='3' fill='#59B6BE' />
              <circle cx='99' cy='19' r='3' fill='#59B6BE' />
              <circle cx='115' cy='19' r='3' fill='#59B6BE' />
              <circle cx='131' cy='19' r='3' fill='#59B6BE' />
              <circle cx='3' cy='35' r='3' fill='#59B6BE' />
              <circle cx='19' cy='35' r='3' fill='#59B6BE' />
              <circle cx='35' cy='35' r='3' fill='#59B6BE' />
              <circle cx='51' cy='35' r='3' fill='#59B6BE' />
              <circle cx='67' cy='35' r='3' fill='#59B6BE' />
              <circle cx='83' cy='35' r='3' fill='#59B6BE' />
              <circle cx='99' cy='35' r='3' fill='#59B6BE' />
              <circle cx='115' cy='35' r='3' fill='#59B6BE' />
              <circle cx='131' cy='35' r='3' fill='#59B6BE' />
              <circle cx='3' cy='51' r='3' fill='#59B6BE' />
              <circle cx='19' cy='51' r='3' fill='#59B6BE' />
              <circle cx='35' cy='51' r='3' fill='#59B6BE' />
              <circle cx='51' cy='51' r='3' fill='#59B6BE' />
              <circle cx='67' cy='51' r='3' fill='#59B6BE' />
              <circle cx='83' cy='51' r='3' fill='#59B6BE' />
              <circle cx='99' cy='51' r='3' fill='#59B6BE' />
              <circle cx='115' cy='51' r='3' fill='#59B6BE' />
              <circle cx='131' cy='51' r='3' fill='#59B6BE' />
              <circle cx='3' cy='67' r='3' fill='#59B6BE' />
              <circle cx='19' cy='67' r='3' fill='#59B6BE' />
              <circle cx='35' cy='67' r='3' fill='#59B6BE' />
              <circle cx='51' cy='67' r='3' fill='#59B6BE' />
              <circle cx='67' cy='67' r='3' fill='#59B6BE' />
              <circle cx='83' cy='67' r='3' fill='#59B6BE' />
              <circle cx='99' cy='67' r='3' fill='#59B6BE' />
              <circle cx='115' cy='67' r='3' fill='#59B6BE' />
              <circle cx='131' cy='67' r='3' fill='#59B6BE' />
              <circle cx='3' cy='83' r='3' fill='#59B6BE' />
              <circle cx='19' cy='83' r='3' fill='#59B6BE' />
              <circle cx='35' cy='83' r='3' fill='#59B6BE' />
              <circle cx='51' cy='83' r='3' fill='#59B6BE' />
              <circle cx='67' cy='83' r='3' fill='#59B6BE' />
              <circle cx='83' cy='83' r='3' fill='#59B6BE' />
              <circle cx='99' cy='83' r='3' fill='#59B6BE' />
              <circle cx='115' cy='83' r='3' fill='#59B6BE' />
              <circle cx='131' cy='83' r='3' fill='#59B6BE' />
            </svg>

            <svg
              className='half-pipe1-svg'
              width='61'
              height='115'
              viewBox='0 0 61 115'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M60.0254 114.966C44.1056 114.966 28.8379 108.91 17.581 98.1295C6.324 87.3494 -9.91821e-05 72.7284 -9.91821e-05 57.483C-9.91821e-05 42.2375 6.32399 27.6165 17.581 16.8364C28.8379 6.05623 44.1056 2.302e-06 60.0254 0L60.0254 57.4829L60.0254 114.966Z'
                fill='#59B6BE'
              />
            </svg>
            <svg
              className='dark-blue-svg1'
              width='283'
              height='250'
              viewBox='0 0 283 295'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18.5442 111.667C7.60996 99.2192 8.73854 79.9178 23.2511 71.9239C30.312 68.0345 37.7168 64.7616 45.3847 62.152C62.5513 56.3095 80.7007 53.9055 98.7964 55.0773C116.892 56.249 134.58 60.9734 150.85 68.9808C167.12 76.9883 181.653 88.122 193.62 101.746C205.587 115.37 214.754 131.218 220.596 148.385C226.439 165.551 228.843 183.701 227.671 201.796C226.499 219.892 221.775 237.58 213.767 253.85C210.19 261.117 205.99 268.038 201.223 274.538C191.424 287.899 172.138 286.529 161.204 274.081L89.874 192.874L18.5442 111.667Z'
                fill='#314D69'
              />
            </svg>

            <video className='vid1' width='100%' muted='1' autoPlay='1' loop='1' playsInline='1'>
              <source
                src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/landing-pages/platform-demo-vid.mov'
                type='video/mp4'
              />
            </video>
            <div className='col-1'></div>
          </div>
        </div>
        <button
          onClick={scrollToQuestionnaire}
          className='maincta marg-top-50'
          data-gtm-click-label='Product Discovery Secondary CTA'
        >
          Request early access
        </button>
      </div>

      <EverythingYouNeed
        headline={
          <h2>
            Getting <span className='how-it-works headline highlight'>connected to a surgeon</span> is free and easy:
          </h2>
        }
        steps={[
          {
            image: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/request.svg' />,
            headline: 'Qualified providers',
            para: 'Find local and respected doctors for your upcoming procedure.',
          },
          {
            image: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/finasurgeon.svg' />,
            headline: '1:1 Support',
            para: 'Talk one on one to recovered patients and ask questions about their experience and recovery.',
          },
          {
            image: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/insnav.jpg' />,
            headline: 'Insurance navigation',
            para: 'Understand what your insurance covers for any procedure and any associated out of pocket costs.',
          },
          {
            image: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/communityicon.jpg' />,
            headline: 'Community',
            para: 'Join a community and build relationships with people who have relatable experiences.',
          },
          {
            image: <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/about.svg' />,
            headline: 'Education',
            para: 'Learn more about your procedure from resources reviewed and approved by doctors.',
          },
        ]}
      />
      <div
        id='product-discovery-landing01'
        className='container-fluid marg-top-20'
        style={{
          position: 'relative',
          backgroundColor: '#F2F2F2',
          paddingBottom: '100px',
          paddingTop: '100px',
        }}
      >
        <h2 className='text-center marg-bottom-30 marg-top-10'> We can’t wait to share this with you.</h2>
        <div className='row justify-content-center'>
          <div className='col-lg-6'>
            <div id='sign-up' className={`last-on-mobile`} style={{ position: 'relative', zIndex: '0' }}>
              <svg
                style={{
                  position: 'absolute',
                  right: '-80px',
                  top: '80px',
                  zIndex: '0',
                }}
                width='57'
                height='113'
                viewBox='0 0 57 113'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0.5 0C15.4847 0 29.8557 5.95266 40.4515 16.5485C51.0473 27.1443 57 41.5153 57 56.5C57 71.4847 51.0473 85.8557 40.4515 96.4515C29.8557 107.047 15.4847 113 0.500008 113L0.5 56.5L0.5 0Z'
                  fill='#59B6BE'
                />
              </svg>
              <svg
                className='dark-blue-svg2'
                width='260'
                height='204'
                viewBox='0 0 260 304'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M245.323 208.048C253.976 222.177 249.575 241.004 233.912 246.408C226.292 249.037 218.438 251 210.437 252.265C192.526 255.097 174.233 254.373 156.601 250.135C138.97 245.897 122.346 238.227 107.678 227.565C93.0108 216.902 80.5872 203.454 71.1167 187.99C61.6462 172.526 55.3143 155.348 52.4826 137.437C49.6509 119.526 50.3748 101.232 54.6129 83.601C58.851 65.9695 66.5204 49.3455 77.1832 34.6781C81.946 28.1266 87.2643 22.0227 93.0698 16.4297C105.002 4.9344 123.772 9.57071 132.425 23.7001L188.874 115.874L245.323 208.048Z'
                  fill='#314D69'
                />
              </svg>
              <svg
                style={{
                  position: 'absolute',
                  top: '-5px',
                  left: '-80px',
                  zIndex: '0',
                }}
                width='134'
                height='86'
                viewBox='0 0 134 86'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle cx='3' cy='3' r='3' fill='#59B6BE' />
                <circle cx='19' cy='3' r='3' fill='#59B6BE' />
                <circle cx='35' cy='3' r='3' fill='#59B6BE' />
                <circle cx='51' cy='3' r='3' fill='#59B6BE' />
                <circle cx='67' cy='3' r='3' fill='#59B6BE' />
                <circle cx='83' cy='3' r='3' fill='#59B6BE' />
                <circle cx='99' cy='3' r='3' fill='#59B6BE' />
                <circle cx='115' cy='3' r='3' fill='#59B6BE' />
                <circle cx='131' cy='3' r='3' fill='#59B6BE' />
                <circle cx='3' cy='19' r='3' fill='#59B6BE' />
                <circle cx='19' cy='19' r='3' fill='#59B6BE' />
                <circle cx='35' cy='19' r='3' fill='#59B6BE' />
                <circle cx='51' cy='19' r='3' fill='#59B6BE' />
                <circle cx='67' cy='19' r='3' fill='#59B6BE' />
                <circle cx='83' cy='19' r='3' fill='#59B6BE' />
                <circle cx='99' cy='19' r='3' fill='#59B6BE' />
                <circle cx='115' cy='19' r='3' fill='#59B6BE' />
                <circle cx='131' cy='19' r='3' fill='#59B6BE' />
                <circle cx='3' cy='35' r='3' fill='#59B6BE' />
                <circle cx='19' cy='35' r='3' fill='#59B6BE' />
                <circle cx='35' cy='35' r='3' fill='#59B6BE' />
                <circle cx='51' cy='35' r='3' fill='#59B6BE' />
                <circle cx='67' cy='35' r='3' fill='#59B6BE' />
                <circle cx='83' cy='35' r='3' fill='#59B6BE' />
                <circle cx='99' cy='35' r='3' fill='#59B6BE' />
                <circle cx='115' cy='35' r='3' fill='#59B6BE' />
                <circle cx='131' cy='35' r='3' fill='#59B6BE' />
                <circle cx='3' cy='51' r='3' fill='#59B6BE' />
                <circle cx='19' cy='51' r='3' fill='#59B6BE' />
                <circle cx='35' cy='51' r='3' fill='#59B6BE' />
                <circle cx='51' cy='51' r='3' fill='#59B6BE' />
                <circle cx='67' cy='51' r='3' fill='#59B6BE' />
                <circle cx='83' cy='51' r='3' fill='#59B6BE' />
                <circle cx='99' cy='51' r='3' fill='#59B6BE' />
                <circle cx='115' cy='51' r='3' fill='#59B6BE' />
                <circle cx='131' cy='51' r='3' fill='#59B6BE' />
                <circle cx='3' cy='67' r='3' fill='#59B6BE' />
                <circle cx='19' cy='67' r='3' fill='#59B6BE' />
                <circle cx='35' cy='67' r='3' fill='#59B6BE' />
                <circle cx='51' cy='67' r='3' fill='#59B6BE' />
                <circle cx='67' cy='67' r='3' fill='#59B6BE' />
                <circle cx='83' cy='67' r='3' fill='#59B6BE' />
                <circle cx='99' cy='67' r='3' fill='#59B6BE' />
                <circle cx='115' cy='67' r='3' fill='#59B6BE' />
                <circle cx='131' cy='67' r='3' fill='#59B6BE' />
                <circle cx='3' cy='83' r='3' fill='#59B6BE' />
                <circle cx='19' cy='83' r='3' fill='#59B6BE' />
                <circle cx='35' cy='83' r='3' fill='#59B6BE' />
                <circle cx='51' cy='83' r='3' fill='#59B6BE' />
                <circle cx='67' cy='83' r='3' fill='#59B6BE' />
                <circle cx='83' cy='83' r='3' fill='#59B6BE' />
                <circle cx='99' cy='83' r='3' fill='#59B6BE' />
                <circle cx='115' cy='83' r='3' fill='#59B6BE' />
                <circle cx='131' cy='83' r='3' fill='#59B6BE' />
              </svg>
              <div
                style={{
                  zIndex: '1',
                  position: 'relative',
                  marginBottom: '-350px',
                }}
                className={`sign-up-otr ${styles.floatbox}`}
              >
                <h6 className={`${styles.heading6} marg-bottom-10`}>Request for early access</h6>
                {success && (
                  <p>
                    Thank you for joining the wait list! We're so excited to share the platform with you. We'll send you
                    an email as soon as we're launched and ready for you to explore.
                  </p>
                )}
                {!success && (
                  <>
                    <p className='shrink marg-bottom-20'>
                      Let us know your location and procedure you're considering. We'll email you as soon as we support
                      your location and procedure!
                    </p>
                    <div className={`material-input ${styles.fulwid}`}>
                      <input
                        type='text'
                        value={fullName}
                        onChange={(event) => {
                          setFullName(event.target.value);
                        }}
                        onBlur={() => validate()}
                        required
                      />
                      <span class='highlight'></span>
                      <span class='bar'></span>
                      <label>Full Name</label>
                    </div>
                    {nameError && <ErrorMessage error={nameError} />}
                    <div className={`material-input ${styles.fulwid}`}>
                      <input
                        type='text'
                        value={email}
                        onChange={(event) => {
                          setEmail(event.target.value);
                        }}
                        onBlur={() => validate()}
                        required
                      />
                      <span class='highlight'></span>
                      <span class='bar'></span>
                      <label>Email</label>
                    </div>
                    {emailError && <ErrorMessage error={emailError} />}

                    <div className={`material-input ${styles.fulwid}`}>
                      <input
                        type='zipcode'
                        value={zipcode}
                        onChange={(event) => {
                          setZipcode(event.target.value);
                        }}
                        onBlur={validate}
                        required
                      />
                      <span class='highlight'></span>
                      <span class='bar'></span>
                      <label>Zip Code</label>
                    </div>
                    {zipError && <ErrorMessage error={zipError} />}
                    <DropdownInput
                      className={`material-input ${styles.fulwid}`}
                      values={chosenEarlyAccess}
                      options={filterableEarlyAccess}
                      setValues={(value) => setChosenEarlyAccess(value)}
                      gtm={`Request for early access - product discovery`}
                      type='multi'
                      multipleSetOpen={''}
                      placeholder={'Request early access for'}
                      light={false}
                      // onBlur={() => validate()}
                    />
                    {earlyAccessError && <ErrorMessage error={earlyAccessError} />}
                    <textarea
                      className={`material-input ${styles.fulwid} ${styles.txtarea}`}
                      placeholder="Procedure(s) you're considering"
                      value={procedures}
                      onChange={(e) => setProcedures(e.target.value)}
                    ></textarea>
                    <AgreeToTerms acceptedTerms={acceptedTerms} setAcceptedTerms={setAcceptedTerms} />
                    <button
                      disabled={
                        checkedName &&
                        checkedEmail &&
                        checkedZipcode &&
                        checkedEarlyAccess &&
                        procedures !== '' &&
                        acceptedTerms === true
                          ? ''
                          : 'disabled'
                      }
                      onClick={onSubmit}
                      className='marg-top-20'
                      style={{ width: '100%' }}
                      data-gtm-click-label='Product Discovery Submit'
                    >
                      Submit request
                    </button>
                    {error && <ErrorMessage error={error} />}
                  </>
                )}
                {loading && (
                  <>
                    <LoadingScreen />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        {/* place grey wave svg here. position: absolute;bottom;0px;left;0px*/}
      </div>
      <svg
        style={{
          position: 'relative',
          bottom: '0px',
          left: '0px',
          width: '100%',
          zIndex: '-1',
          marginBottom: '200px',
        }}
        viewBox='0 0 1438 198'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M505.341 194.32C128.717 220.802 8.18711 97.8752 -5 33.1018V0H1438V145.893C1327.39 108.296 1117.55 65.5907 964.747 97.4665C845.889 122.261 611.333 183.49 505.341 194.32Z'
          fill='#F2F2F2'
        />
      </svg>
    </div>
  );
}
